'use client'

import type React from 'react'
import { createContext } from 'react'

import { PeerAccountProvider } from '~/app/_components'
import type { FullProjectAsViewerFragment } from '~/generated/graphql'

export type ProjectContextType = {
  project?: FullProjectAsViewerFragment
}

export const ProjectContext = createContext<ProjectContextType>({} as ProjectContextType)

export function ProjectProvider({
  project,
  children,
}: React.PropsWithChildren & { project: FullProjectAsViewerFragment | null }) {
  if (!project) return null
  return (
    <PeerAccountProvider account={project.account}>
      <ProjectContext.Provider value={{ project }}>{children}</ProjectContext.Provider>
    </PeerAccountProvider>
  )
}
